import React, {PureComponent} from 'react';
import BoardItem from "../Components/BoardItem";
import {api} from "../utils/api";
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Skeleton} from 'antd';

import {fetchMoreObjects, fetchObjects} from "../store/actions";
import IndexTrending from "../Components/IndexTrending";
import style from '../../css/Index.css';
import IndexPersons from "../Components/IndexPersons";
import LoadMoreButton from "../Components/LoadingMoreButton";
import IndexFeatured from "../Components/IndexFeatured";
import IndexUpdated from "../Components/IndexUpdated";


class IndexScreen extends PureComponent {
  static propTypes = {}

  componentDidMount() {
    this.refresh();
  }

  refresh = async () => {
    let {dispatch} = this.props;
    dispatch(fetchObjects('indexBundle'));
  };

  onLoadMore = async () => {
    let {dispatch, indexRecords} = this.props;

    if (!indexRecords.loadingMore && indexRecords.next) {
      dispatch(fetchMoreObjects('indexRecords', indexRecords.next));
    }
  }

  render() {
    let {indexRecords, indexBundle} = this.props;
    let {list} = indexRecords;
    console.log('loadingMore', indexRecords.loadingMore)

    return (
        <div>
          <div className={"container-fluid "}>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <section className={style.main_content}>
                  <div>
                    <IndexFeatured/>
                    {/*<IndexPersons/>*/}
                    {/*{featuredRecords.list.map((boardItem) => {*/}
                    {/*  return <div style={{width: '300px', height: '168px'}}>*/}
                    {/*    {boardItem.object.title}*/}
                    {/*  </div>*/}
                    {/*})}*/}
                  </div>
                  <br/>
                  {/*<hr/>*/}

                  {/*<div className="btn-toolbar btn-group btn-group-sm">*/}
                  {/*  <a href="" className="btn btn-primary">推荐</a>*/}
                  {/*  <a href="" className="btn btn-light">热点</a>*/}
                  {/*  <a href="" className="btn btn-light">科技</a>*/}
                    {/*<a href="" className="btn btn-light">文化</a>*/}
                    {/*<a href="" className="btn btn-light">体育</a>*/}
                    {/*<a href="" className="btn btn-light">娱乐</a>*/}
                  {/*</div>*/}
                  {/*<br/>*/}

                  <div>
                    {/*<h3 className={style.section_title}>*/}
                    {/*  <span>*/}
                    {/*    最新话题*/}
                    {/*  </span>*/}
                    {/*</h3>*/}
                    {/*<br/>*/}
                    {/*<LoadingIndicator loading={indexBundle.loading}/>*/}

                    {indexBundle.loading ? <Skeleton active={true} /> : null}

                    {list.map((boardItem) => {
                      return <BoardItem key={'b' + boardItem.id} board={boardItem}/>
                    })}

                    <LoadMoreButton
                        loading={indexRecords.loadingMore}
                        onClick={this.onLoadMore}
                        hasNext={indexRecords.next}/>
                    <br/>
                    <br/>
                  </div>
                </section>
              </div>

              <div className="col-md-4 col-sm-12">
                {/*<h3 className={style.side_section_title}>*/}
                {/*  广告*/}
                {/*</h3>*/}

                {/*<div style={{*/}
                {/*  width: '100%',*/}
                {/*  height: '80px',*/}
                {/*  backgroundColor: 'var(--control-background)',*/}
                {/*  borderRadius: '5px',*/}
                {/*  padding: '0.5rem',*/}
                {/*  margin: '0.5rem 0',*/}
                {/*}}>*/}
                {/*  <p>*/}
                {/*    卖肥料啦，亩产1080，豆类植物，天然有机肥。￥150一袋。*/}
                {/*  </p>*/}
                {/*</div>*/}

                <div className={style.side_bar}>
                  <section className={style.side_section}>
                    <h3 className={style.side_section_title}>
                      趋势
                    </h3>
                    <IndexTrending/>
                  </section>

                  <section className={style.side_section}>
                    <h3 className={style.side_section_title}>
                      往事进展
                    </h3>
                    <IndexUpdated/>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }
}

export default connect(({indexRecords, featuredRecords, indexBundle}) => ({
  indexRecords,
  featuredRecords,
  indexBundle
}))(IndexScreen);
